import { render, staticRenderFns } from "./NotificationsFollowingsList.vue?vue&type=template&id=20091d75&scoped=true&"
import script from "./NotificationsFollowingsList.vue?vue&type=script&lang=ts&"
export * from "./NotificationsFollowingsList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsFollowingsList.vue?vue&type=style&index=0&id=20091d75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20091d75",
  null
  
)

export default component.exports